import inView from "in-view";

export default function setInview() {
  inView.threshold(0.35);
  inView('.js-inview')
    .on('enter', el => {
      el.setAttribute('data-animation', 'start');
    });

}
